<script lang="ts">
	import { InputLabel } from '../../../../../../components/InputLabel';
	import { Radio } from '../../../../../../components/Radio';
	import type { RadioValue } from '../../../../../../components/Radio/types';
	import { filterStores } from '../../../../state';
	import type { FilterCheckboxList, FilterDrawerState } from '../../../../types';
	import { getFilterCollectionValue } from '../../../../utils/getFilterCollectionValue/getFilterCollectionValue';
	import { setFilterCollectionValue } from '../../../../utils/setFilterCollectionValue/setFilterCollectionValue';

	interface Props {
		filterCollectionId: string;
		filterCheckboxList: FilterCheckboxList;
	}

	let { filterCollectionId, filterCheckboxList }: Props = $props();

	const ALL = 'All';

	const { filterStore } = filterStores;

	let hasSelectAll = $derived(filterCheckboxList?.select_all);

	let filterValue = $derived(
		getFilterCollectionValue<string[]>({
			filterCollectionId,
			filter: $filterStore as FilterDrawerState
		})
	);

	let group = $derived(filterValue?.[0] || ALL);

	let name = $derived(`filter-${filterCollectionId}`);

	let radios = $derived(filterCheckboxList?.filter_checkboxes);
	let dataCyPrefix = $derived(`filter-drawer-radios-id-${filterCollectionId}`);

	const handleSelectAllChange = () =>
		setFilterCollectionValue({
			filterCollectionId,
			value: []
		});

	const handleChange = (value: RadioValue) =>
		setFilterCollectionValue({
			filterCollectionId,
			value: [value as string]
		});
</script>

<!-- TODO filter drawer : adjust data-cy -->
{#if radios}
	<div class="flex w-full flex-col gap-4">
		{#if hasSelectAll}
			<InputLabel dataCy={`${dataCyPrefix}-all`}
				><Radio
					dataCy={`${dataCyPrefix}-all-label`}
					{name}
					onChange={handleSelectAllChange}
					value={ALL}
					{group}
				/> All</InputLabel
			>
		{/if}

		{#each radios as radio}
			{#if radio?.id && radio.value}
				<InputLabel dataCy={dataCyPrefix}
					><Radio
						dataCy={`${dataCyPrefix}-label`}
						{name}
						value={radio.value}
						onChange={handleChange}
						{group}
					/>

					{radio?.label}
				</InputLabel>
			{/if}
		{/each}
	</div>
{/if}
